import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HomeworkService from "../../services/homework.service";

export const getHomework = createAsyncThunk(
  "homework/getHomework",
  async (payload, thunkAPI) => {
    try {
      const response = await HomeworkService.getHomework(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addHomework = createAsyncThunk(
  "homework/addHomework",
  async (data, thunkAPI) => {
    try {
      const response = await HomeworkService.addHomework(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updateHomework = createAsyncThunk(
  "homework/updateHomework",
  async (payload, thunkAPI) => {
    try {
      const response = await HomeworkService.updateHomework(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteHomework = createAsyncThunk(
  "homework/deleteHomework",
  async (id, thunkAPI) => {
    try {
      const response = await HomeworkService.deleteHomework(id);
      return id; 
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  homeworklist: [],
  updateSuccess: false,
};

/* =================== Slice =================== */

const homeworkSlice = createSlice({
  name: "homework",
  initialState,

  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ---------- Get Homework ---------- */
      .addCase(getHomework.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHomework.fulfilled, (state, action) => {
        state.loading = false;
        state.homeworklist = action.payload?.data || [];
      })
      .addCase(getHomework.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add Homework ---------- */
      .addCase(addHomework.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addHomework.fulfilled, (state, action) => {
        state.loading = false;
        state.homeworklist.unshift(action.payload?.data);
      })
      .addCase(addHomework.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update Homework ---------- */
      .addCase(updateHomework.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateHomework.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const updated = action.payload?.data;
        if (updated?._id) {
          const index = state.homeworklist.findIndex(
            (hw) => hw._id === updated._id
          );
          if (index !== -1) {
            state.homeworklist[index] = updated;
          }
        }
      })
      .addCase(updateHomework.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
     /* ---------- Delete Homework ---------- */
.addCase(deleteHomework.pending, (state) => {
  state.loading = true;
  state.error = null;
})

.addCase(deleteHomework.fulfilled, (state, action) => {
  state.loading = false;
  state.homeworklist = state.homeworklist.filter(
    (hw) => hw._id !== action.payload
  );
})

.addCase(deleteHomework.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload;
});

  },
});

export const { resetUpdateStatus } = homeworkSlice.actions;
export default homeworkSlice.reducer;
